import { IApplicationState } from '../../types/redux';

export const selectUrlsForShare = (cianHost: string) => (state: IApplicationState) => {
  const urls = [];

  // eslint-disable-next-line guard-for-in
  for (let key in state.selected) {
    const selectedEntity = state.selected[key];
    const url = cianHost + selectedEntity.fullUrl;
    urls.push(url);
  }

  return urls;
};
